const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 07/12/16.
 */
const React = require('react');

const {formatText} = require('core/i18n').i18n;
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const PoliticalChargeCountry = require('../PoliticalChargeCountry/PoliticalChargeCountry');

const formHelper = require('../../../utilities/formHelper');
require('./PoliticalCharge.scss');


class PoliticalCharge extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            initialState = {
                didHavePoliticalCharge: this.props.values.didHavePoliticalCharge,
                politicalCountrySpainSelected: this.props.values.politicalCountrySpainSelected,
                politicalCountryForeignSelected: this.props.values.politicalCountryForeignSelected,
                politicalChargeDescription: this.props.values.politicalChargeDescription,
                component_id: 'politicalCharge'
            };
        } else {
            initialState = {
                didHavePoliticalCharge: false,
                politicalCountrySpainSelected: false,
                politicalCountryForeignSelected: false,
                politicalChargeDescription: '',
                component_id: 'politicalCharge'
            };
        }
        this.state = initialState;
        this.showPoliticalChargeCountry = this.showPoliticalChargeCountry.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.onTextareaChange = this.onTextareaChange.bind(this);
        this.buildRadioGroup = this.buildRadioGroup.bind(this);
    }

    onCheckboxChange(event) {
        //If the user enter a description , but after uncheck the options , clean the description
        if ((this.state.politicalCountryForeignSelected && this.state.politicalCountrySpainSelected) === false) {
            this.setState({politicalChargeDescription: ''});
        }

        if (event.target.id === 'politicalChargeCountrySpain') {
            this.setState({
                politicalCountrySpainSelected: event.target.checked
            })
        } else {
            this.setState({
                politicalCountryForeignSelected: event.target.checked
            });
        }
    }

    onTextareaChange(event) {
        this.setState({politicalChargeDescription: event.target.value});
    }


    buildRadioButton(radioButton) {
        return (

            <RadioButton
                label={radioButton.label}
                value={radioButton.value}
                className="block-step__radio"/>
        );
    }


    buildRadioGroup(options) {
        return (<RadioButtonGroup
            name="politicalcharge"
            idPrefix="politicalchargeRadio"
            className="block-step__radio-group"
            selectedValue={this.state.didHavePoliticalCharge}
            onChange={this.handleRadioChange}
        >
            {options}
        </RadioButtonGroup>);
    }

    //Handlers

    handleRadioChange(event) {
        event = formHelper.stringToBoolean(event);
        if (event === this.props.withOption) {
            this.setState({didHavePoliticalCharge: event});
        } else {
            this.setState({
                didHavePoliticalCharge: event,
                politicalCountrySpainSelected: false,
                politicalCountryForeignSelected: false,
                politicalChargeDescription: ''
            });
        }
    }

    showPoliticalChargeCountry() {
        if (this.state.didHavePoliticalCharge === this.props.withOption) {
            const politicalCountryOptions =
                [
                    {
                        id: 'politicalChargeCountrySpain',
                        value: this.state.politicalCountrySpainSelected,
                        label: 'En España'
                    },
                    {
                        id: 'politicalChargeCountryForeign',
                        value: this.state.politicalCountryForeignSelected,
                        label: 'En el extranjero'
                    }
                ];
            return (
                <PoliticalChargeCountry
                    values={this.props.values}
                    politicalChargeCountryOptions={politicalCountryOptions}
                    state={this.state}
                    handleCheckboxChange={this.onCheckboxChange}
                    handleTextareaChange={this.onTextareaChange}
                />
            )
        } else {
            return null;
        }
    }


    render() {
        this.props.dataReceiver(this.state);
        let options = [];
        this.props.politicalChargeOptions.forEach(option => {
            options.push(this.buildRadioButton(option));
        });
        switch (this.props.type) {
            case 'single':
                return (
                    <div className="political-charge">
                        <div
                            className="ok-slider__text">{formatText('contractsView-checkingAccountPoliticalChargeFirstRadioGroupTitle')}</div>
                        {this.buildRadioGroup(options)}
                        {this.showPoliticalChargeCountry()}
                    </div>);
            case 'form':
                return (
                    <div className="ok-slider">
                        <div
                            className="ok-slider__text">{formatText('contractsView-checkingAccountPoliticalChargeSecondRadioGroupTitle')}</div>
                        <div className="ok-slider__slider-box">
                            {this.buildRadioGroup(options)}
                            {this.showPoliticalChargeCountry()}
                        </div>
                    </div>
                )
        }
    }

}

PoliticalCharge.propTypes = {
    politicalChargeOptions: PropTypes.array,
    dataReceiver: PropTypes.func,
    withOption: PropTypes.bool,
    values: PropTypes.any,
    type: PropTypes.string
};


module.exports = PoliticalCharge;